import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBriefcase, FiShoppingBag, FiShield, FiBookOpen, FiHome } = FiIcons;

const WhoWeHelp = () => {
  const clientTypes = [
    {
      icon: FiBriefcase,
      title: 'Small Business',
      description: 'Scalable phone systems that grow with your business'
    },
    {
      icon: FiShoppingBag,
      title: 'Retail & E-commerce',
      description: 'Multi-location support with centralized management'
    },
    {
      icon: FiShield,
      title: 'Professional Services',
      description: 'HIPAA-compliant systems with secure call recording'
    },
    {
      icon: FiBookOpen,
      title: 'Education',
      description: 'Budget-friendly solutions for educational institutions'
    },
    {
      icon: FiHome,
      title: 'Government',
      description: 'Secure, compliant communication for municipal offices'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="w-4/5 mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Built for Every Business
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Powerful features and integrations to support organizations of any size
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8">
          {clientTypes.map((client, index) => (
            <motion.div
              key={index}
              className="text-center p-6 rounded-xl hover:bg-gray-50 transition-colors"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={client.icon} className="h-8 w-8 text-primary-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {client.title}
              </h3>
              <p className="text-gray-600 text-sm">
                {client.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeHelp;